import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import getNodeUrl from '@frontend/utils/rpcRandom';
import { chainData } from '@jdiyield/constants';
import { Chain } from '@jdiyield/interfaces';
import throat from 'throat';
import Web3 from 'web3';
export var initialWallet = {
  totalWallet: 0,
  totalWorth: 0,
  totalReward: 0,
  totalDebt: 0,
  totalLPValue: 0,
  totalCollateral: 0,
  platforms: [],
  assets: [],
  loading: false
};
export var walletQuery = function walletQuery(_ref) {
  var platforms = _ref.platforms,
      tokens = _ref.tokens,
      baseLpTokens = _ref.baseLpTokens,
      coinList = _ref.coinList,
      setWallet = _ref.setWallet;
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
      var chainID, address, _ref2$excludes, excludes, excludesPlatforms, walletAddress;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              chainID = _ref2.chainID, address = _ref2.address, _ref2$excludes = _ref2.excludes, excludes = _ref2$excludes === void 0 ? [] : _ref2$excludes;
              excludesPlatforms = platforms.filter(function (platform) {
                return !excludes.includes(platform.name);
              });

              if (chainID === 999) {
                terraQuery(address, tokens.filter(function (token) {
                  return token.chain === Chain.TERRA;
                }), coinList)(setWallet({
                  address: address,
                  chainID: chainID
                }));
              } else {
                walletAddress = address;
                if (chainID === 2020) walletAddress = address.replace('ronin:', '0x');
                ethQuery(walletAddress, excludesPlatforms.filter(function (platform) {
                  var _chainData$chainID;

                  return platform.chain === ((_chainData$chainID = chainData[chainID]) === null || _chainData$chainID === void 0 ? void 0 : _chainData$chainID.chainName);
                }), tokens.filter(function (token) {
                  var _chainData$chainID2;

                  return token.chain === ((_chainData$chainID2 = chainData[chainID]) === null || _chainData$chainID2 === void 0 ? void 0 : _chainData$chainID2.chainName);
                }), baseLpTokens[chainID], coinList, chainID)(setWallet({
                  address: address,
                  chainID: chainID
                }));
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref3.apply(this, arguments);
    };
  }();
};

function addPlatform(newData) {
  return function (prev) {
    try {
      var _ref4, _newData$nftResults;

      var newPlatforms = (_ref4 = _toConsumableArray(prev.platforms)) !== null && _ref4 !== void 0 ? _ref4 : [];
      var index = prev.platforms.findIndex(function (old) {
        return old.name === newData.name;
      });
      var platformNotEmpty = [(_newData$nftResults = newData.nftResults) === null || _newData$nftResults === void 0 ? void 0 : _newData$nftResults.length, newData.totalWorth, newData.totalReward, newData.totalDebt, newData.totalCollateral, newData.totalLPValue].some(function (value) {
        return value !== 0;
      });

      if (platformNotEmpty) {
        if (index === -1) {
          //? new one
          newPlatforms.push(newData);
        } else {
          newPlatforms[index] = newData;
        }
      }

      var _newPlatforms$reduce = newPlatforms.reduce(function (prev, curr) {
        var totalDebt = curr.totalDebt,
            totalLPValue = curr.totalLPValue,
            totalWorth = curr.totalWorth,
            totalReward = curr.totalReward,
            totalCollateral = curr.totalCollateral;
        return {
          totalLPValue: prev.totalLPValue + totalLPValue,
          totalWorth: prev.totalWorth + totalWorth,
          totalReward: prev.totalReward + totalReward,
          totalDebt: prev.totalDebt + totalDebt,
          totalCollateral: prev.totalCollateral + totalCollateral
        };
      }, {
        totalWorth: 0,
        totalReward: 0,
        totalDebt: 0,
        totalLPValue: 0,
        totalCollateral: 0
      }),
          totalWorth = _newPlatforms$reduce.totalWorth,
          totalReward = _newPlatforms$reduce.totalReward,
          totalDebt = _newPlatforms$reduce.totalDebt,
          totalLPValue = _newPlatforms$reduce.totalLPValue,
          totalCollateral = _newPlatforms$reduce.totalCollateral;

      return _objectSpread(_objectSpread({}, prev), {}, {
        platforms: newPlatforms,
        totalWorth: totalWorth,
        totalReward: totalReward,
        totalDebt: totalDebt,
        totalLPValue: totalLPValue,
        totalCollateral: totalCollateral
      });
    } catch (error) {
      console.log(error);
      return prev;
    }
  };
}

function removePlatform(platformTitle) {
  return function (prev) {
    return _objectSpread(_objectSpread({}, prev), {}, {
      platforms: prev.platforms.filter(function (platform) {
        return platform.title !== platformTitle;
      })
    });
  };
}

var option = {
  clientConfig: {
    keepalive: true,
    keepaliveInterval: 60000 // milliseconds

  },
  reconnect: {
    auto: true,
    delay: 2500,
    onTimeout: true
  }
}; //? BSC Polygon

export var ethQuery = function ethQuery(account, bscPlatforms, tokens, baseLpTokens, coinList, chainID) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(setState) {
      var option, providers, web3, _yield$import, generatedPairs, getAssets, queryFarm, queryLending, queryLpToken, queryNFT, _yield$import2, summaryTotalLending, summaryTotalLP, summaryTotalStakes, assets, totalWallet, baseLPGenerate, platforms;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!account || Object.keys(coinList).length === 0)) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return", setState(initialWallet));

            case 2:
              setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  address: account,
                  chainID: chainID,
                  loading: true
                });
              });
              option = {
                clientConfig: {
                  keepalive: true,
                  keepaliveInterval: 60000 // milliseconds

                },
                reconnect: {
                  auto: true,
                  delay: 2500,
                  onTimeout: true
                }
              };
              providers = false ? {
                1: getNodeUrl(1),
                56: new Web3.providers.WebsocketProvider('wss://bsc-rpcws.moonrhythm.io', option),
                137: new Web3.providers.WebsocketProvider('wss://matic-rpcws.moonrhythm.io', option),
                2020: new Web3(getNodeUrl(2020)),
                43114: new Web3(getNodeUrl(43114)),
                250: new Web3(getNodeUrl(250))
              } : {
                1: getNodeUrl(1),
                56: new Web3(getNodeUrl(56)),
                137: new Web3(getNodeUrl(137)),
                2020: new Web3(getNodeUrl(2020)),
                43114: new Web3(getNodeUrl(43114)),
                250: new Web3(getNodeUrl(250))
              };
              web3 = new Web3(providers[chainID]);
              _context3.next = 8;
              return import('@jdiyield/contracts');

            case 8:
              _yield$import = _context3.sent;
              generatedPairs = _yield$import.generatedPairs;
              getAssets = _yield$import.getAssets;
              queryFarm = _yield$import.queryFarm;
              queryLending = _yield$import.queryLending;
              queryLpToken = _yield$import.queryLpToken;
              queryNFT = _yield$import.queryNFT;
              _context3.next = 17;
              return import('@jdiyield/utils');

            case 17:
              _yield$import2 = _context3.sent;
              summaryTotalLending = _yield$import2.summaryTotalLending;
              summaryTotalLP = _yield$import2.summaryTotalLP;
              summaryTotalStakes = _yield$import2.summaryTotalStakes;
              _context3.next = 23;
              return getAssets({
                web3: web3,
                walletAddress: account,
                tokens: tokens,
                coinList: coinList,
                chainID: chainID
              });

            case 23:
              assets = _context3.sent;
              // //? summary total wallet
              totalWallet = assets.reduce(function (prev, cur) {
                var valueUSD = cur.valueUSD;
                return prev + valueUSD;
              }, 0);
              setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  assets: assets,
                  totalWallet: totalWallet
                });
              });
              baseLPGenerate = baseLpTokens || generatedPairs(chainID, tokens); //? Farm

              platforms = bscPlatforms.map(throat(16, /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(platform) {
                  var _yield$queryFarm, _yield$queryLpToken, _platform$lendContrac, _platform$lendContrac2;

                  var stakes, nftResults, balancesLP, lending, _summaryTotalLending, totalDebt, totalCollateral, _summaryTotalStakes, totalReward, totalWorth, noEmptyStakes, lpTokens, _summaryTotalLP, totalLPValue;

                  return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return queryFarm({
                            web3: web3,
                            chainID: chainID,
                            account: account,
                            priceList: coinList,
                            platform: platform,
                            tokens: [].concat(_toConsumableArray(tokens), _toConsumableArray((platform === null || platform === void 0 ? void 0 : platform.specialCaseTokens) || []))
                          });

                        case 2:
                          _context2.t1 = _yield$queryFarm = _context2.sent;
                          _context2.t0 = _context2.t1 !== null;

                          if (!_context2.t0) {
                            _context2.next = 6;
                            break;
                          }

                          _context2.t0 = _yield$queryFarm !== void 0;

                        case 6:
                          if (!_context2.t0) {
                            _context2.next = 10;
                            break;
                          }

                          _context2.t2 = _yield$queryFarm;
                          _context2.next = 11;
                          break;

                        case 10:
                          _context2.t2 = [];

                        case 11:
                          stakes = _context2.t2;
                          _context2.next = 14;
                          return queryNFT(web3, account, platform, chainID);

                        case 14:
                          nftResults = _context2.sent;
                          _context2.next = 17;
                          return queryLpToken({
                            web3: web3,
                            account: account,
                            platform: platform,
                            tokens: tokens,
                            baseLPGenerate: baseLPGenerate,
                            priceList: coinList,
                            chainID: chainID
                          });

                        case 17:
                          _context2.t4 = _yield$queryLpToken = _context2.sent;
                          _context2.t3 = _context2.t4 !== null;

                          if (!_context2.t3) {
                            _context2.next = 21;
                            break;
                          }

                          _context2.t3 = _yield$queryLpToken !== void 0;

                        case 21:
                          if (!_context2.t3) {
                            _context2.next = 25;
                            break;
                          }

                          _context2.t5 = _yield$queryLpToken;
                          _context2.next = 26;
                          break;

                        case 25:
                          _context2.t5 = [];

                        case 26:
                          balancesLP = _context2.t5;
                          _context2.next = 29;
                          return Promise.all((_platform$lendContrac = platform === null || platform === void 0 ? void 0 : (_platform$lendContrac2 = platform.lendContracts) === null || _platform$lendContrac2 === void 0 ? void 0 : _platform$lendContrac2.map(function (lendContract) {
                            return queryLending(web3, account, lendContract, tokens, coinList);
                          })) !== null && _platform$lendContrac !== void 0 ? _platform$lendContrac : []);

                        case 29:
                          lending = _context2.sent;
                          _summaryTotalLending = summaryTotalLending(lending), totalDebt = _summaryTotalLending.totalDebt, totalCollateral = _summaryTotalLending.totalCollateral;
                          _summaryTotalStakes = summaryTotalStakes(stakes, coinList), totalReward = _summaryTotalStakes.totalReward, totalWorth = _summaryTotalStakes.totalWorth, noEmptyStakes = _summaryTotalStakes.noEmptyStakes;

                          if (balancesLP.length > 0 || totalReward > 0 || totalWorth > 0 || totalCollateral > 0 || totalDebt > 0 || nftResults.length > 0) {
                            lpTokens = balancesLP.map(function (balanceLP) {
                              var _platform$specialCase;

                              return _objectSpread(_objectSpread({}, balanceLP), {}, {
                                platformName: platform.name,
                                chain: platform.chain,
                                removeLP: !(platform !== null && platform !== void 0 && (_platform$specialCase = platform.specialCaseTokens) !== null && _platform$specialCase !== void 0 && _platform$specialCase.some(function (_ref7) {
                                  var address = _ref7.address;
                                  return address === balanceLP.lpAddress;
                                }))
                              });
                            });
                            _summaryTotalLP = summaryTotalLP(lpTokens), totalLPValue = _summaryTotalLP.totalLPValue;
                            setState(addPlatform(_objectSpread(_objectSpread({}, platform), {}, {
                              lpTokens: lpTokens,
                              lending: lending,
                              nftResults: nftResults,
                              stakes: noEmptyStakes,
                              totalCollateral: totalCollateral,
                              totalLPValue: totalLPValue,
                              totalReward: totalReward,
                              totalWorth: totalWorth,
                              totalDebt: totalDebt
                            })));
                          } else {
                            setState(removePlatform(platform.title));
                          }

                        case 33:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                }));

                return function (_x3) {
                  return _ref6.apply(this, arguments);
                };
              }()));
              _context3.next = 30;
              return Promise.allSettled(platforms);

            case 30:
              setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  loading: false
                });
              });

            case 31:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
}; //? Terra

export var terraQuery = function terraQuery(account, tokens, coinList) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(setState) {
      var chainID, _yield$import3, queryAssets, _yield$import4, summaryTotalStakes, _yield$import5, getStaking, assets, totalWallet, stakes, _summaryTotalStakes2, totalReward, totalWorth, noEmptyStakes;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              chainID = 999;

              if (!(!account || Object.keys(coinList).length === 0)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return", setState(initialWallet));

            case 3:
              setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  address: account,
                  chainID: chainID,
                  loading: true
                });
              });
              _context4.next = 6;
              return import('@jdiyield/contracts');

            case 6:
              _yield$import3 = _context4.sent;
              queryAssets = _yield$import3.queryAssets;
              _context4.next = 10;
              return import('@jdiyield/utils');

            case 10:
              _yield$import4 = _context4.sent;
              summaryTotalStakes = _yield$import4.summaryTotalStakes;
              _context4.next = 14;
              return import('@frontend/utils/terra/mirror');

            case 14:
              _yield$import5 = _context4.sent;
              getStaking = _yield$import5.getStaking;
              _context4.next = 18;
              return queryAssets({
                walletAddress: account,
                tokens: tokens,
                priceList: coinList
              });

            case 18:
              assets = _context4.sent;
              totalWallet = assets.reduce(function (prev, cur) {
                var valueUSD = cur.valueUSD;
                return prev + valueUSD;
              }, 0);
              setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  assets: assets,
                  totalWallet: totalWallet
                });
              }); //TODO verify account is terra address ?

              _context4.next = 23;
              return getStaking(account);

            case 23:
              stakes = _context4.sent;
              _summaryTotalStakes2 = summaryTotalStakes(stakes, coinList), totalReward = _summaryTotalStakes2.totalReward, totalWorth = _summaryTotalStakes2.totalWorth, noEmptyStakes = _summaryTotalStakes2.noEmptyStakes;
              setState(addPlatform({
                name: 'Mirror',
                title: 'Mirror',
                chain: Chain.TERRA,
                link: 'https://terra.mirror.finance/',
                logo: 'https://i.postimg.cc/pLJK7LpK/M1o7x-Ab-T-o.png',
                lpTokens: [],
                symbol: 'MIR',
                isDollar: true,
                stakes: noEmptyStakes,
                totalCollateral: 0,
                totalLPValue: 0,
                totalReward: totalReward,
                totalWorth: totalWorth,
                totalDebt: 0
              }));
              setState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  loading: false
                });
              });

            case 27:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref8.apply(this, arguments);
    };
  }();
};